import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, LoadableSchema, Transitions } from "../../types"

export const assignSubjectsMenuState: StateNodeConfig<
  Context,
  LoadableSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    openAssignMenu: true
  }),
  exit: assign<Context>({
    openAssignMenu: false,
    selectedClassRecord: null,
    selectedSubjects: []
  }),
  initial: "idle",
  states: {
    idle: {
      on: {
        TOGGLE_SUBJECT: {
          actions: assign<Context, any>((ctx, evt) => ({
            selectedSubjects: ctx.selectedSubjects.includes(evt.subject)
              ? ctx.selectedSubjects.filter(s => s !== evt.subject)
              : [...ctx.selectedSubjects, evt.subject]
          }))
        },
        ASSIGN_SUBJECTS: {
          target: "loading"
        },
        CANCEL: {
          target: "#ManageUserModules.classes_page.idle"
        }
      }
    },
    loading: {
      entry: assign<Context>(ctx => ({
        loading: { ...ctx.loading, edit: true }
      })),
      exit: assign<Context>(ctx => ({
        loading: { ...ctx.loading, edit: false }
      })),
      invoke: {
        id: "editClass",
        src: "editClass",
        onDone: {
          target: "#ManageUserModules.classes_page",
          actions: assign((_ctx, _evt) => ({
            snackbar: {
              message: `Successfully assigned subjects to class.`,
              withUndo: false,
              error: false
            }
          }))
        },
        onError: {
          target: "#ManageUserModules.classes_page.idle",
          actions: assign((_ctx, _evt) => ({
            snackbar: {
              message: `An error occurred while trying to assign subjects to class. Please try again. If the error persists, contact support for help.`,
              withUndo: false,
              error: true
            }
          }))
        }
      }
    }
  }
}
